import React from 'react';
import './CheckBox.module.scss';

type Props = {
  checked: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

export default function CheckBox({ checked, onClick }: Props) {
  return (
    <div onClick={onClick} styleName="wrapper">
      <input type="checkbox" checked={checked} />
    </div>
  );
}
